

export const BUTTON_VARIANT_PRIMARY = 'primary'
export const BUTTON_VARIANT_SECONDARY = 'secondary'
export const BUTTON_VARIANT_NEUTRAL = 'neutral'
export const BUTTON_VARIANT_DANGER = 'danger'
export const BUTTON_VARIANT_NEGATIVE = 'negative'

export const BUTTON_SIZE_SM = 'sm'
export const BUTTON_SIZE_MD = 'md'
export const BUTTON_SIZE_LG = 'lg'
